export const OPTION_ADD_RESOURCE_ID = 'add-resource';
export const OPTION_ADD_RESOURCE_LABEL = 'Upload new file';
export const SELECTED_OPTION_KEY = {
  name: 'name',
  content: 'content',
};
